/**
 * The one Twig pattern that genuinely is the same everywhere: an output tag embedded
 * in a longer string.
 *
 * ### Why only this one is shared
 *
 * The editor has several matchers that all *look* like "recognise `{{ 'x'|trans }}`",
 * and they are deliberately **not** merged:
 *
 * | Matcher | Must match | Must not |
 * |---|---|---|
 * | `insertion.TRANS_PATTERN` | any chained filters (`\|trans\|upper`) | — |
 * | `insertion.TRANS_KEY_PATTERN` | keys inside `{% include … with { a: 'k'\|trans } %}` | — |
 * | `richTextValue.TRANS_EXPRESSION` | `\|raw`, captured separately | other filters, which stay opaque atoms |
 * | `translationBinding.WHOLE_BINDING` | the *entire* value, anchored | a value with words around it |
 *
 * Unifying them means choosing one tolerance for all four, and each one is load-bearing
 * for a different behaviour: extraction, preview substitution, round-tripping, and
 * whether a field counts as bound. `isExpressionValue` being one character too loose
 * already produced a silently mangled body (`a }} and {{ b`), so the four stay separate
 * and this file records why.
 *
 * **Consumers must use `matchAll` or `replace`.** Both are safe with a shared
 * `/g/` instance; `test`/`exec` in a loop would carry `lastIndex` between callers.
 */

/**
 * One `{{ … }}`, non-greedy so two in a row stay separate. The interior is returned
 * verbatim — no assumption about what kind of expression it is.
 */
export const EMBEDDED_EXPRESSION = /\{\{([\s\S]*?)\}\}/g;
